// extracted by mini-css-extract-plugin
module.exports = {"section":"HorizontalScrollSection_section__c7TPR","sectionTitle":"HorizontalScrollSection_sectionTitle__JW3JB","itemsContainer":"HorizontalScrollSection_itemsContainer__fmZ7B"};